<template>
  <div>
    <v-alert  :value="true"  v-if="errorMessage != null" type="error" >{{ errorMessage }}</v-alert>
    <v-alert  :value="true"  v-if="successMessage != null" type="error" >{{ successMessage }}</v-alert>
  </div>
</template>

<script>
    
  export default {
    components: {
      
    },
    data () {
      return {
        errorMessage: null,
        successMessage: null
      }
    },
    mounted () {
      console.log('Hit AUTH LOGOUT script')
      this.$signOut();
      this.successMessage = 'You have successfully signed out'

    }
  }
</script>